/** @format */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DelegationEntry } from 'src/app/store/application';

@Injectable()
export class DelegationsService {
	delegationsUrl = 'api/delegations';

	httpOptions = {
		headers: new HttpHeaders({
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		}),
	};

	constructor(private httpClient: HttpClient) {}

	getUserDelegations(): Observable<DelegationEntry[]> {
		return this.httpClient.get<DelegationEntry[]>(this.delegationsUrl, this.httpOptions);
	}

	getTimekeeperDelegations(): Observable<DelegationEntry[]> {
		return this.httpClient.get<DelegationEntry[]>(`${this.delegationsUrl}/timekeeperDelegations`, this.httpOptions);
	}

	getAllDelegations(): Observable<DelegationEntry[]> {
		return this.httpClient.get<DelegationEntry[]>(`${this.delegationsUrl}/allDelegations`, this.httpOptions);
	}

	addDelegation(newDelegation: DelegationEntry): Observable<any> {
		return this.httpClient.post(this.delegationsUrl, newDelegation, this.httpOptions);
	}

	updateDelegation(delegation: DelegationEntry): Observable<any> {
		return this.httpClient.put(this.delegationsUrl, delegation, this.httpOptions);
	}

	deleteDelegation(id: number): Observable<any> {
		return this.httpClient.delete(`${this.delegationsUrl}/${id}`, this.httpOptions);
	}
}
